"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgTransFatFree = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM5.68 7.094A8 8 0 0 0 16.905 18.32l-1.623-1.623A4.823 4.823 0 0 1 12 18c-2.072 0-3.895-1.346-4.644-3.344-.656-1.748-.39-3.73.678-5.207L5.68 7.094ZM7.094 5.68A8 8 0 0 1 18.32 16.905l-1.846-1.845c.062-.131.119-.266.17-.404.725-1.931.325-4.147-1.041-5.655l-2.12-2.343a2 2 0 0 0-2.966 0L9.356 7.942 7.094 5.68Zm2.134 8.274a3.614 3.614 0 0 1 .25-3.062l4.389 4.389c-.52.456-1.174.719-1.867.719-1.213 0-2.308-.807-2.772-2.046Zm1.544-4.596 4.137 4.137c.255-1.119-.035-2.32-.788-3.151L12 8l-1.228 1.358Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgTransFatFree);
//# sourceMappingURL=SvgTransFatFree.js.map